"use client";
import { track } from "@vercel/analytics/react";
import Link from "next/link";

const LinkWithTracking = ({
  href,
  children,
  trackData,
  ...props
}: {
  href: string;
  children: React.ReactNode;
  trackData: {
    name: string;
    value: any;
  };
  [key: string]: any;
}) => {
  const handleClick = () => {
    track(trackData.name, trackData.value);
  };

  return (
    <Link href={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};

export default LinkWithTracking;
